import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = {
  key: 0,
  class: "card-title"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Unclaimed Cases", -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_12 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, "Case Id", -1)
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 0,
  class: "card mt-5"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Processing Cases")
], -1)
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_23 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, "Case Id", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", null, "Claimed By", -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}

import { ref, onMounted, inject } from "vue";
import {
  SupportTabStatus,
  CaseStatusTypes,
} from "@/core/types/SupportStatusTypes";
import SupportService from "../services/SupportService";
import CaseDetail from "../components/CaseDetail.vue";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";

enum ActionType {
  Close = "Close",
  Claim = "Claim",
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CaseIndex',
  setup(__props) {

const isLoading = ref(false);
const tabStatus = SupportTabStatus;
const data = ref(<any>[]);
const processingData = ref(<any>[]);
const tab = ref(tabStatus.Pending);
const caseDetailRef = ref<any>(null);

const criteria = ref({
  page: 1,
  size: 25,
  statuses: [CaseStatusTypes.Created],
});

const processingCriteria = ref({
  page: 1,
  size: 25,
  statuses: [CaseStatusTypes.Processing, CaseStatusTypes.Replied],
});

const changeTab = (_tab: any) => {
  tab.value = _tab;
  if (tab.value == tabStatus.All) {
    criteria.value.statuses = null;
  } else {
    criteria.value.statuses = [tab.value];
  }
  fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  try {
    criteria.value.page = _page;

    const res = await SupportService.queryCasesList(criteria.value);

    if (tab.value === tabStatus.Pending) {
      fetchProcessingData(_page);
    }
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const fetchProcessingData = async (_page: number) => {
  isLoading.value = true;
  try {
    processingCriteria.value.page = _page;
    const res = await SupportService.queryCasesList(processingCriteria.value);
    processingData.value = res.data;
    processingCriteria.value = res.criteria;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const show = (item: any) => {
  caseDetailRef.value.show(item);
};

const claimCase = async (id: number) => {
  try {
    const res = await SupportService.claimCase(id);
    console.log(res);
  } catch (error) {
    console.log(error);
  }
};

const closeCase = async (id: number) => {
  try {
    const res = await SupportService.closeCase(id);
    console.log(res);
  } catch (error) {
    console.log(error);
  }
};

const openConfirmModal = inject<any>(
  TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL
);
const openConfirmPanel = (_action: ActionType, id: number) => {
  openConfirmModal?.(() => {
    return {
      [ActionType.Claim]: () => claimCase(id),
      [ActionType.Close]: () => closeCase(id),
    }
      [_action]()
      .then(() => {
        fetchData(criteria.value.page);
      });
  });
};

const getTagType = (status) => {
  switch (status) {
    case CaseStatusTypes.Processing:
      return "badge-primary";
    case CaseStatusTypes.Replied:
      return "badge-warning";
    case CaseStatusTypes.Created:
      return "badge-success";
    case CaseStatusTypes.Closed:
      return "badge-danger";
    default:
      return ""; // Default type or you can define a default type
  }
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass([
          'nav-link text-active-primary pb-4',
          { active: tab.value === _unref(tabStatus).Pending },
        ]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab(_unref(tabStatus).Pending)))
        }, _toDisplayString(_ctx.$t("status.pending")), 3)
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass([
          'nav-link text-active-primary pb-4',
          { active: tab.value === _unref(tabStatus).Resolved },
        ]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab(_unref(tabStatus).Resolved)))
        }, _toDisplayString(_ctx.$t("status.completed")), 3)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("a", {
          class: _normalizeClass([
          'nav-link text-active-primary pb-4',
          { active: tab.value === _unref(tabStatus).All },
        ]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab(_unref(tabStatus).All)))
        }, _toDisplayString(_ctx.$t("status.all")), 3)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (tab.value === _unref(SupportTabStatus).Pending)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", _hoisted_11, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.category")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              (tab.value != _unref(SupportTabStatus).Pending)
                ? (_openBlock(), _createElementBlock("td", _hoisted_14, "Claimed By"))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.caseId), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t("title." + item.categoryName)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", getTagType(item.status)])
                        }, _toDisplayString(_unref(CaseStatusTypes)[item.status]), 3)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      (tab.value != _unref(SupportTabStatus).Pending)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(item.claimedAdminName), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", null, [
                        (item.status == _unref(CaseStatusTypes).Created)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "success",
                              onClick: ($event: any) => (openConfirmPanel(ActionType.Claim, item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Claim")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (show(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.view")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (item.status != _unref(CaseStatusTypes).Closed)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              type: "danger",
                              onClick: ($event: any) => (openConfirmPanel(ActionType.Close, item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    (tab.value === _unref(SupportTabStatus).Pending)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("table", _hoisted_22, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.category")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.status")), 1),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                  _hoisted_25,
                  _createElementVNode("td", null, _toDisplayString(_ctx.$t("fields.action")), 1)
                ])
              ]),
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
                    _createVNode(_component_LoadingRing)
                  ]))
                : (!isLoading.value && processingData.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                      _createVNode(_component_NoDataBox)
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processingData.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(item.caseId), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.$t("title." + item.categoryName)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", getTagType(item.status)])
                            }, _toDisplayString(_unref(CaseStatusTypes)[item.status]), 3)
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_TimeShow, {
                              "date-iso-string": item.createdOn
                            }, null, 8, ["date-iso-string"])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.claimedAdminName), 1),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: ($event: any) => (show(item))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.view")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_button, {
                              type: "danger",
                              onClick: ($event: any) => (openConfirmPanel(ActionType.Close, item.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]))
            ]),
            _createVNode(_component_TableFooter, {
              onPageChange: fetchData,
              criteria: criteria.value
            }, null, 8, ["criteria"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(CaseDetail, {
      ref_key: "caseDetailRef",
      ref: caseDetailRef
    }, null, 512)
  ], 64))
}
}

})